import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { BasePageView } from "by/gamefactory/cityversetycoon/scenes/common/components/BasePageView";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { UnboardingType } from "../../../components/unboarding/UnboardingType";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";
import { RenterAdditionalPageTextContainer } from "../../../components/unboarding/textcontainers/RenterAdditionalPageTextContainer";
import { UnboardingAvatarsContainer } from "../../../components/unboarding/UnboardingAvatarsContainer";

export class AdditionalRenterPage extends BasePageView {
    private static readonly BUTTON_TEXT = "NEXT";

    private readonly operationControls: PromiseCompletionSource<void>;
    private readonly commonResources: CommonResourcesPackage;
    private readonly unboardingResources: UnboardingResourcePackage;
    private readonly type: UnboardingType;

    private rightLight: Sprite;
    private leftLight: Sprite;
    private background: Sprite;
    private button: ButtonWithScaleAnimation;
    private avatarsContainer: UnboardingAvatarsContainer;
    private textContainer: RenterAdditionalPageTextContainer;

    public constructor(
        operationControls: PromiseCompletionSource<void>,
        commonResources: CommonResourcesPackage,
        unboardingResources: UnboardingResourcePackage,
        canvasScaler: ICanvasScaler,
        type: UnboardingType
    ) {
        super(canvasScaler);
        this.operationControls = operationControls;
        this.commonResources = commonResources;
        this.unboardingResources = unboardingResources;
        this.type = type;
        this.build();
    }

    protected override build(): void {
        this.rightLight = new Sprite(this.unboardingResources.assets_views_unboarding_yellow_side_light_png);
        this.rightLight.pivot.x = this.rightLight.width;
        this.addChild(this.rightLight);
        this.leftLight = new Sprite(this.unboardingResources.assets_views_unboarding_yellow_side_light_png);
        this.leftLight.pivot.x = this.leftLight.width;
        this.leftLight.scale.x = -1;
        this.addChild(this.leftLight);
        this.background = new Sprite(this.unboardingResources.assets_views_unboarding_renter_additional_background_png);
        this.addChild(this.background);
        this.avatarsContainer = new UnboardingAvatarsContainer(this.unboardingResources, this.commonResources);
        this.addChild(this.avatarsContainer);
        this.textContainer = new RenterAdditionalPageTextContainer();
        this.addChild(this.textContainer);
        this.button = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_button_green_png);
        this.button.width = 297;
        this.button.height = 156;
        this.button.onUp.add(this.buttonClickHandle, this);
        this.addChild(this.button);
        const buttonText = new Text(AdditionalRenterPage.BUTTON_TEXT, new ButtonTextStyle());
        buttonText.position.set(105, 39);
        this.button.defaultView.addChild(buttonText);
        super.build();
    }

    private buttonClickHandle() {
        this.button.interactive = false;
        this.operationControls.complete();
    }

    protected override layout(width: number, height: number): void {
        this.leftLight.position.set(0, 610);
        this.rightLight.position.set(width, 636);
        this.avatarsContainer.position.set(150, 478);
        this.textContainer.position.set(202, 846);
        this.button.position.set(264, 1550);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.button.onUp.remove(this.buttonClickHandle, this);
        super.destroy(options);
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super({
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 0.5,
            dropShadowBlur: 5,
            dropShadowDistance: 4,
            fontSize: 85,
            leading: 15,
            letterSpacing: 5.25
        });
    }
}